import { useCallback } from 'react';

import { Segment } from '../../../services/analytics-services/segment';
import { useSellerOnboardingVariant } from '../../../hooks/use-seller-setting';

export const useProgressiveDisclosureSegmentTracking = (event) => {
  const onboardingVariant = useSellerOnboardingVariant();
  return useCallback(
    (data) => {
      Segment.trackEvent(event, {
        ...data,
        onboardingVariant,
      });
    },
    [event, onboardingVariant],
  );
};
